import React, { useState } from 'react';
import { Button, Form, FormGroup, Label, Input, Col, Row, Alert } from 'reactstrap';
import axios from 'axios';
import CompanyMultiTextInput from './CompanyMultiTextInput.jsx';
import CompanyCirclesInput from './CompanyCirclesInput.jsx';
import CompanyImageInput from './CompanyImageInput.jsx';
import '../../assets/css/InputFormStyle.css';
import { COMPANY_URL, REQUEST_HEADERS } from '../../constants.js';

const CompanyInputForm = (props) => {
  const {
    onUpdate,
    onCancel,
    companyData
  } = props;

  let inputStartDate = null;
  if (companyData != null && companyData.born_at != null && companyData.born_at !== '') {
    const { born_at } = companyData;
    inputStartDate = new Date(born_at.year, born_at.month - 1, born_at.day)
      .toISOString()
      .slice(0, 10);
  }

  const [name, setName] = useState(companyData?.name ?? '');
  const [startDate, setStartDate] = useState(inputStartDate ?? '');
  const [sector, setSector] = useState(companyData?.sector ?? '');
  const [businessActivity, setBusinessActivity] = useState(companyData?.business_activity ?? '');
  const [mainActivity, setMainActivity] = useState(companyData?.main_activity ?? '');
  const [mainProducts, setMainProducts] = useState(companyData?.main_products ?? []);
  const [address, setAddress] = useState(companyData?.address ?? '');
  const [contact, setContact] = useState(companyData?.contact ??
  {
    'area': '',
    'office_phone': '',
    'mobile_phone': '',
    'email': '',
    'website': '',
  });
  const [circleSkills, setCircleSkills] = useState(companyData?.circle_skills ?? {})
  const [image, setImage] = useState(companyData?.image ?? {});
  const [alert, setAlert] = useState({});
  const [isSaving, setIsSaving] = useState(false);

  const onChangeContact = (event) => {
    const info = Object.assign({}, contact);
    info[event.target.name] = event.target.value;
    setContact(info);
  }

  const getRequestPayload = () => {
    const date = startDate.split('-');
    return {
      name,
      address,
      born_at: {
        year: date[0],
        month: date[1],
        day: date[2],
      },
      sector,
      business_activity: businessActivity,
      main_activity: mainActivity,
      main_products: mainProducts,
      contact,
      image,
      circle_skills: circleSkills
    };
  }

  const save = () => {
    setIsSaving(true);
    axios({
      url: COMPANY_URL + (companyData != null ? '/' + companyData.uuid : ''),
      method: companyData != null ? 'PUT' : 'POST',
      data: getRequestPayload(),
      headers: REQUEST_HEADERS
    }).then((response) => {
      if (onUpdate != null) {
        onUpdate(response.data);
      }
      setIsSaving(false);
      onCancel();
    }).catch(error => {
      setIsSaving(false);
      setAlert({
        message: error?.response?.data?.message,
        color: 'danger'
      });
    });
  }

  return (
    <div>
      {alert.message != null ?
        <Alert color={alert.color}>{alert.message}</Alert>
        : null}
      <Form className="input-company-form">
        <Row>
          <Col sm={8}>
            <FormGroup>
              <Label for="name">Nombre</Label>
              <Input
                type="text"
                name="name"
                id="name"
                value={name}
                onChange={(event) => setName(event.target.value)} />
            </FormGroup>
          </Col>
          <Col sm={4}>
            <CompanyImageInput
              label="Logo"
              setImageInfo={setImage}
              setAlert={setAlert} />
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <FormGroup>
              <Label for="start_date">Fecha de Inicio</Label>
              <Input
                type="date"
                name="start_date"
                id="start_date"
                value={startDate}
                onChange={(event) => setStartDate(event.target.value)} />
            </FormGroup>
          </Col>
          <Col sm={4}>
            <FormGroup>
              <Label for="sector">Sector</Label>
              <Input
                type="text"
                name="sector"
                id="sector"
                value={sector}
                onChange={(event) => setSector(event.target.value)} />
            </FormGroup>
          </Col>
          <Col sm={4}>
            <FormGroup>
              <Label for="business_activity">Giro</Label>
              <Input
                type="select"
                name="business_activity"
                id="business_activity"
                value={businessActivity}
                onChange={(event) => setBusinessActivity(event.target.value)}>
                <option></option>
                <option>Productora</option>
                <option>Comercio</option>
                <option>Servicio</option>
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <FormGroup>
          <Label for="main_activity">Actividad Principal</Label>
          <Input
            type="textarea"
            name="main_activity"
            id="main_activity"
            value={mainActivity}
            onChange={(event) => setMainActivity(event.target.value)} />
        </FormGroup>
        <CompanyMultiTextInput
          label="Productos o Servicios"
          inputList={mainProducts}
          updateInputList={setMainProducts} />
        <Row className="subtitle">
          <h3>Datos de Contacto</h3>
        </Row>
        <Row>
          <Col sm={6}>
            <FormGroup>
              <Label for="contact_area">Area de Contacto</Label>
              <Input
                type="text"
                name="area"
                id="area"
                value={contact.area}
                onChange={onChangeContact} />
            </FormGroup>
          </Col>
          <Col sm={6}>
            <FormGroup>
              <Label for="email">Email</Label>
              <Input
                type="email"
                name="email"
                id="email"
                value={contact.email}
                onChange={onChangeContact} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <FormGroup>
              <Label for="telephone">Teléfono</Label>
              <Input
                type="text"
                name="office_phone"
                id="office_phone"
                value={contact.office_phone}
                onChange={onChangeContact} />
            </FormGroup>
          </Col>
          <Col sm={6}>
            <FormGroup>
              <Label for="cellphone">Celular</Label>
              <Input
                type="text"
                name="mobile_phone"
                id="mobile_phone"
                value={contact.mobile_phone}
                onChange={onChangeContact} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <FormGroup>
              <Label for="website">Sitio Web</Label>
              <Input
                type="url"
                name="website"
                id="website"
                value={contact.website}
                onChange={onChangeContact} />
            </FormGroup>
          </Col>
          <Col sm={8}>
            <FormGroup>
              <Label for="address">Dirección</Label>
              <Input
                type="text"
                name="address"
                id="address"
                value={address}
                onChange={(event) => setAddress(event.target.value)} />
            </FormGroup>
          </Col>
        </Row>
        <CompanyCirclesInput
          circleSkills={circleSkills}
          setCircleSkills={setCircleSkills} />
        <FormGroup check row>
          <Col sm={{ offset: 10 }}>
            <Button
              size="sm"
              color="secondary"
              className="input-text-btn"
              onClick={onCancel}>
              Cancelar
          </Button>
            <Button
              size="sm"
              color="primary"
              className="input-text-btn"
              disabled={isSaving}
              onClick={save}>
              Guardar
          </Button>
          </Col>
        </FormGroup>
      </Form>
    </div>
  );
}

export default CompanyInputForm;
